// `audio.extract`: a video's own sound as an MP3, live's `EXTRACT_AUDIO` (spec G14-templates,
// "The steps"), the worker's own ffmpeg. Live lists no such job; a template's run starts it.
import { AudioExtractQuote, AudioExtractRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"audio.extract"> = {
  type: "audio.extract",
  label: "Audio",
  source: "form",
  pair: "audio.extract",
  fields: () => ({}),
  request: AudioExtractRequest,
  quote: AudioExtractQuote,
};
